export const FINAL_STEP_PROGRESS = 96;

export const UPSALE_MILESTONES = [
  { icon: 'checked', labelKey: 'core_plan_progress_bar_label', activeFrom: 0 },
  { icon: 'progress-upgrades', labelKey: 'rec_upgrades_progress_bar_label', activeFrom: FINAL_STEP_PROGRESS },
  { icon: 'progress-access', labelKey: 'access_progress_bar_label', activeFrom: FINAL_STEP_PROGRESS },
];
